module.exports = __webpack_public_path__ + "img/img-glow.ca322d2e.png";